import styled from "styled-components";

export const ContainerAdd = styled.div`
padding:44px 24px;
.title{
    font-family: SFProDisplay;
font-size: 16px;
line-height: 18px;
/* identical to box height, or 112% */
margin-bottom:32px;
letter-spacing: 0.533333px;
font-weight:600;
color: #2D3A45;
}
.text{
    font-family: SFProDisplay;
font-size: 12px;
line-height: 18px;
/* identical to box height, or 150% */
margin-bottom:5px;
letter-spacing: 0.4px;
opacity:0.6;
color: #2D3A45;
}
.input{
    border: 1px solid #EDEFF3;
box-sizing: border-box;
border-radius: 6px;
width:318px;
height:44px;
margin-bottom:16px;
outline:none;
padding:10px
}

.savebtn{
    background: #20D472;
border-radius: 4px;
color:white;
width:118px;
height:35px;
outline:none;
border:none;
margin-top:424px;
}
.select{
    border: 1px solid #EDEFF3;
    border-bottom-right-radius:6px;
    border-top-right-radius:6px;
box-sizing: border-box;
width:274px;
height:44px;
outline:none;
}

`